import { httpGet, httpGetBlob } from '../utils/fetchService';
const baseURL = '/api/development/schema-compare';

export const fetchSchemasForTaxYear = async ({ taxYear }) => {
  try {
    const schemasForTaxYearResponse = await httpGet({
      route: `${baseURL}/schemas-list/${taxYear}`,
      errorMessage: 'Error fetching Schemas For Tax Year',
    });
    const schemasForTaxYearList = await schemasForTaxYearResponse.json();
    return schemasForTaxYearList;
  } catch (error) {
    return [];
  }
};

export const fetchSchemasCompareReport = async ({
  newTaxYear,
  oldTaxYear,
  selectedNewSchema,
  selectedOldSchema,
}) => {
  const blob = await httpGetBlob({
    route: `${baseURL}/report/${newTaxYear}/${oldTaxYear}/${selectedNewSchema.value}/${selectedOldSchema.value}`,
    errorMessage: 'Error generating Schemas Compare Report',
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Schema_Compare_Report_${newTaxYear}_${selectedNewSchema.value}_${selectedNewSchema.key}_vs_${oldTaxYear}_${selectedOldSchema.value}_${selectedOldSchema.key}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
